import { render, staticRenderFns } from "./Faturamento.vue?vue&type=template&id=85ff76e2&"
import script from "./Faturamento.vue?vue&type=script&lang=js&"
export * from "./Faturamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports